// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2f14a478","488":"f2d8c907","977":"0f3ae48b"}[chunkId] + ".chunk.js";
};